webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-blue-999ed7182c0c8bccbaa3997938a4df58.svg";

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_logo_orkla_blue_svg__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_logo_orkla_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_logo_orkla_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_logo_orkla_tagline_no_svg__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_logo_orkla_tagline_no_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_logo_orkla_tagline_no_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_logo_orkla_tagline_no_white_svg__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_logo_orkla_tagline_no_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_logo_orkla_tagline_no_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_logo_orkla_tagline_com_svg__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_logo_orkla_tagline_com_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_logo_orkla_tagline_com_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_logo_orkla_tagline_com_white_svg__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_logo_orkla_tagline_com_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_logo_orkla_tagline_com_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_logo_orkla_tagline_dk_svg__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_logo_orkla_tagline_dk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_logo_orkla_tagline_dk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_logo_orkla_tagline_dk_white_svg__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_logo_orkla_tagline_dk_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_logo_orkla_tagline_dk_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_logo_orkla_tagline_es_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_logo_orkla_tagline_es_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_logo_orkla_tagline_es_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_logo_orkla_tagline_se_svg__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_logo_orkla_tagline_se_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_logo_orkla_tagline_se_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_logo_orkla_tagline_se_white_svg__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_logo_orkla_tagline_se_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_logo_orkla_tagline_se_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_logo_orkla_tagline_fi_png__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_logo_orkla_tagline_fi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_logo_orkla_tagline_fi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_logo_orkla_tagline_fi_svg__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_logo_orkla_tagline_fi_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_logo_orkla_tagline_fi_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_logo_orkla_tagline_fi_white_png__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_logo_orkla_tagline_fi_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_logo_orkla_tagline_fi_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_logo_orkla_tagline_fi_white_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_logo_orkla_tagline_fi_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_logo_orkla_tagline_fi_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_logo_without_payoff_svg__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_logo_without_payoff_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_logo_without_payoff_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_logo_orkla_black_svg__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_logo_orkla_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_logo_orkla_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_logo_orkla_gray_svg__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_logo_orkla_gray_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_logo_orkla_gray_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_logo_orkla_denmark_footer_svg__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_logo_orkla_denmark_footer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_logo_orkla_denmark_footer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_favicon_ico__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_file_formats__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_climate_img__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_social_medias__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_step_number_icons__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_product_labels__ = __webpack_require__(8);
// Bootstrap Modules, jQuery and other Bootstrap dependencies provided by Webpack


// Import scripts


// Images























// Icons




// Product labels



/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orkla_klimatskala_png__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orkla_klimatskala_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orkla_klimatskala_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Ilmastoj_lki_taulukko_jpeg__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Ilmastoj_lki_taulukko_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Ilmastoj_lki_taulukko_jpeg__);



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_svg__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__file_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__link_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__link_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mp3_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mp3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mp3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__other_svg__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__other_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__other_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pdf_svg__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xlsx_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xlsx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__xlsx_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ics_svg__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ics_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ics_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__webcast_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__webcast_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__webcast_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__presentation_svg__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__presentation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__presentation_svg__);
    
   
    
    
    
   




/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plus_icon_svg__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plus_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plus_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__minus_icon_svg__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__minus_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__minus_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrow_down_white_svg__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrow_down_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__arrow_down_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__arrow_down_svg__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__arrow_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__arrow_down_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cross_white_svg__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cross_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cross_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cross_svg__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cross_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cross_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__new_window_link_svg__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__new_window_link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__new_window_link_svg__);









/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fi_battre_val_png__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fi_battre_val_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fi_battre_val_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fi_blue_flag_png__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fi_blue_flag_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fi_blue_flag_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fi_eu_leaf_png__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fi_eu_leaf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fi_eu_leaf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fi_utz_cocoa_png__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fi_utz_cocoa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fi_utz_cocoa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fi_msc_png__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fi_msc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fi_msc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fi_blue_swan_png__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fi_blue_swan_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fi_blue_swan_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nyckelhal_farg_png__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nyckelhal_farg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__nyckelhal_farg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ASC_logo_png__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ASC_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ASC_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MSC_Swedish_Portrait_Blue_RGB_png__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MSC_Swedish_Portrait_Blue_RGB_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MSC_Swedish_Portrait_Blue_RGB_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fr_n_sverige_png__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fr_n_sverige_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fr_n_sverige_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__krav_marke_farg_png__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__krav_marke_farg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__krav_marke_farg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__eu_organic_logo_png__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__eu_organic_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__eu_organic_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utz_certified_logo_svg_png__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utz_certified_logo_svg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Utz_certified_logo_svg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fi_rainforest_alliance_cocoa_png__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fi_rainforest_alliance_cocoa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__fi_rainforest_alliance_cocoa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fi_rainforest_alliance_cocoa_hazelnut_png__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fi_rainforest_alliance_cocoa_hazelnut_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fi_rainforest_alliance_cocoa_hazelnut_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Rainforest_kakao_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Rainforest_kakao_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Rainforest_kakao_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__OFF_ClimateLabel_FI_03_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__OFF_ClimateLabel_FI_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__OFF_ClimateLabel_FI_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__allergiatunnus_fi_4vari_png__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__allergiatunnus_fi_4vari_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__allergiatunnus_fi_4vari_png__);




















/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facebook_icon_small_svg__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facebook_icon_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__facebook_icon_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instagram_icon_small_svg__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instagram_icon_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__instagram_icon_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linked_in_icon_small_svg__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linked_in_icon_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__linked_in_icon_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__twitter_icon_small_svg__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__twitter_icon_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__twitter_icon_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__youtube_icon_small_svg__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__youtube_icon_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__youtube_icon_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pinterest_icon_small_svg__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pinterest_icon_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pinterest_icon_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mail_icon_small_svg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mail_icon_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__mail_icon_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__print_svg__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__print_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__print_svg__);










/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filled_1_filled_svg__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filled_1_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__filled_1_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filled_2_filled_svg__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filled_2_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__filled_2_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filled_3_filled_svg__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filled_3_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__filled_3_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filled_4_filled_svg__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filled_4_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__filled_4_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filled_5_filled_svg__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filled_5_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filled_5_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filled_6_filled_svg__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filled_6_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__filled_6_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filled_7_filled_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filled_7_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__filled_7_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filled_8_filled_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filled_8_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__filled_8_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filled_9_filled_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filled_9_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__filled_9_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filled_10_filled_svg__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filled_10_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__filled_10_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filled_11_filled_svg__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filled_11_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__filled_11_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filled_12_filled_svg__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filled_12_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__filled_12_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filled_13_filled_svg__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filled_13_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__filled_13_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filled_14_filled_svg__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filled_14_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__filled_14_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filled_15_filled_svg__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filled_15_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__filled_15_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filled_16_filled_svg__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filled_16_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__filled_16_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filled_17_filled_svg__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filled_17_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__filled_17_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filled_18_filled_svg__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filled_18_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__filled_18_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filled_19_filled_svg__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filled_19_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__filled_19_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__filled_20_filled_svg__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__filled_20_filled_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__filled_20_filled_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lined_1_lined_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lined_1_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__lined_1_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lined_2_lined_svg__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lined_2_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__lined_2_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lined_3_lined_svg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lined_3_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__lined_3_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lined_4_lined_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lined_4_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__lined_4_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lined_5_lined_svg__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lined_5_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__lined_5_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lined_6_lined_svg__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lined_6_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__lined_6_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lined_7_lined_svg__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lined_7_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__lined_7_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lined_8_lined_svg__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lined_8_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__lined_8_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lined_9_lined_svg__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lined_9_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__lined_9_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lined_10_lined_svg__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lined_10_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__lined_10_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lined_11_lined_svg__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lined_11_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__lined_11_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lined_12_lined_svg__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lined_12_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__lined_12_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lined_13_lined_svg__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lined_13_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__lined_13_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__lined_14_lined_svg__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__lined_14_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__lined_14_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__lined_15_lined_svg__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__lined_15_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__lined_15_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__lined_16_lined_svg__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__lined_16_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__lined_16_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__lined_17_lined_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__lined_17_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__lined_17_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__lined_18_lined_svg__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__lined_18_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__lined_18_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__lined_19_lined_svg__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__lined_19_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__lined_19_lined_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__lined_20_lined_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__lined_20_lined_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__lined_20_lined_svg__);










































/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_grid_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_grid_content_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_grid_content_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_filter_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_iframe_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_iframe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_iframe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_accordion_collapse_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_accordion_collapse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_accordion_collapse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_eurolandtoolsintegrationobject__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_eurolandtoolsintegrationobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_eurolandtoolsintegrationobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_cookie_bar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_image_slider__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_image_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modules_image_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_mobile_menu_collapse__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_mobile_menu_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modules_mobile_menu_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_video_modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_video_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modules_video_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_faq__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modules_faq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_tabs_module__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_tabs_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modules_tabs_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_hero_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_hero_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modules_hero_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__partials_recipe_time_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__partials_recipe_time_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__partials_recipe_time_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__partials_sub_nav_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__partials_sub_nav_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__partials_sub_nav_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_annual_report_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_annual_report_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_annual_report_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_brands_detail_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_brands_detail_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_brands_detail_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_faq_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_faq_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_faq_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_downloadcenter_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_downloadcenter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_downloadcenter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_single_recipes_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_single_recipes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_single_recipes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_single_quiz_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_single_quiz_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_single_quiz_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_sillkampen_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_sillkampen_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_sillkampen_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_archive_orklaway_documents_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_archive_orklaway_documents_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_archive_orklaway_documents_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layout_header_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layout_header_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__layout_header_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__layout_parallax_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__layout_parallax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__layout_parallax_js__);
// Bootstrap Modules, jQuery and other Bootstrap dependencies provided by Webpack































/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function() {
	$('body').on('click', 'header .main-navbar-toggler', function () {
		$('html, body').toggleClass('modal-open');
	});

	$('.main-navbar-toggler').click(function(){
		$('#main-menu-toggler').toggleClass('open');
	});

    $("#navbar").on("click", "button", function(){
		$(this).blur();
	});

	// Hide a collapsed sub navbar if triggering mega menu.
	$('.dropdown-toggler').on('click', function() {
		if($('.sub-nav-content').hasClass('show')) {
			$('.navbar-collapse').collapse('hide');
		}
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
	var areClipPathShapesSupported = function () {
		var base = 'clipPath';
		var prefixes = [ 'webkit', 'moz', 'ms', 'o', '' ];
		var properties = [ base ];
		var testElement = document.createElement( 'testelement' );
		var attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

		for ( var i = 0, l = prefixes.length; i < l; i++ ) {
			var prefixedProperty = prefixes[i] + base.charAt( 0 ).toUpperCase() + base.slice( 1 ); // remember to capitalize!
			properties.push( prefixedProperty );
		}

		for ( var i = 0, l = properties.length; i < l; i++ ) {
			var property = properties[i];
			if ( testElement.style[property] === '' ) {
				testElement.style[property] = attribute;
				if ( testElement.style[property] !== '' ) {
					return true;
				}
			}
		}
		
		return false;
	};
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

	if (!isSafari && areClipPathShapesSupported()) {
		$('body').addClass('parallax-supported-clip-path');
	} else {
		$('body').addClass('parallax-supported-clip');
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function(){
    $(".accordion-dropdown-text").each(function(i) {
        $(this).attr('id', "accordion" + (i + 1));
    });

    $('.accordion-toggle').each(function(i) {
        $(this).attr('href', "#accordion" + (i + 1));
    });

    $('.accordion-toggle').on('click', function() {
        var active = $(this).next('.accordion-dropdown-text');

        active.toggleClass("border border-top-0 border-right-0 border-left-0");
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


$(document).ready(function() {
  const closeElement = $('.js-cookie-bar-close')

  if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('orkla_cookie_consent') === undefined) {
    $('.js-cookie-bar').toggleClass('d-none')
  }

  closeElement.on('click', function () {
    $('.js-cookie-bar').toggleClass('d-none')
  })

  //Cookies.set('orkla_cookie_consent', true)
})
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! Developed by Illimar Pihlamäe | e-mail: illimar@idra.pri.ee | Euroland Estonia © 2014 | e-mail: illimar@euroland.com */
var EurolandToolIntegrationObject = new (function() {
	
	var This = this
		,iFrameArr = [] //an array, that holds all of the iframes
		,hasScrollBar = false
		,IE_Version = getDocumentModeIE()
		,hasListiners = false
		,dummyCallback = function() {}
	;
	
	function removeHash(url) {
		var index = url.indexOf('#');
		if(index > -1) {
			url = url.substring(0, index);
		}
		return url
	}

	function messageCall(e) {
		if(!e) e = window.event;
		switch(e.origin) {
			case 'http://tools.eurolandir.com':
			case 'https://tools.eurolandir.com':
			case 'http://tools.euroland.com':
			case 'https://tools.euroland.com':
			case 'http://asia.tools.euroland.com':
			case 'https://asia.tools.euroland.com':
			case 'http://gamma1n.euroland.com':
			case 'https://gamma1n.euroland.com':
			case 'http://gamma.euroland.com':
			case 'https://gamma.euroland.com':
				break;
			default:
				var arr = e.origin.split('.');
				if(arr < 2) 
					return;
				if(arr[arr.length-1] != 'com' || arr[arr.length - 2] != 'euroland')
					return;
				break;
		}
		
		var obj, item, offset;
		try {
			obj = JSON.parse(e.data);
		} catch(e) {
			return;
		}
		
		if(obj.iFrame) {
			if(typeof obj.iFrame.height == 'number') {
				if(typeof obj.iFrame.index == 'number' && iFrameArr.length > obj.iFrame.index) {
					item = iFrameArr[obj.iFrame.index];
					if(item.height < 0) {
						item.height = parseFloat(item.iFrame.offsetHeight);
					}
					offset = obj.iFrame.height - item.height;
					item.iFrame.height = obj.iFrame.height;
					item.height = obj.iFrame.height;
					item.iFrame.style.height = obj.iFrame.height + 'px';
					
					if(item.callback != dummyCallback) {
						item.callback(offset);
					}
				}
			}
		}
	};

	function getDocumentModeIE() {
	/*
		Returns the IE's DocumentMode for IE, for non IE 0 is returned.
	*/
		if(document.all) {
			return typeof document.documentMode == 'undefined' ? getIE_Version() : Math.floor(parseFloat(document.documentMode));
		} 		
		return 0;
	}
	
	function getIE_Version() {
	/*
		Returns the current IE version. Returns 0 if the browser is not a IE.
	*/
		if(!document.all) //if the browser is not a IE returns 0
			return 0;
		if(IE_Version != null) //if the browser version has already been found returns that
			return IE_Version;
		
		//Finds out the IE version
		var index
			,browser = navigator.userAgent
		;		
		
		index = browser.search('MSIE');
		if(index == -1)
			return 0;
		
		IE_Version = browser.substring(index + 4, browser.indexOf(';', index));
		IE_Version = Math.floor(parseFloat(IE_Version));
		return IE_Version;
	}
	
	function setIFrame(iFrame, resizeCallback, isHeightToParent) {
	/*
		Sets the IFrame in the object
		iFrame - the HTML DOM object of the IFrame
		
		reziseCallback - Function, the callback that will be called with the iframe's offset passed to it
		isHeightToParent - Boolean, if set to TRUE the AutoHeight will ask the height to be sent to the parent and not into the top window
	*/
		var obj = {
			iFrame : iFrame
			,index : iFrameArr.length
			,height : -1 //the current height of the iframe
			,callback : resizeCallback
		}, strActivationMessage;
		
		iFrame.width = "100%"; 
		iFrame.allowTransparency = true;
		iFrame.style.background = 'transparent';
		// iFrame.style.overflow = 'hidden';
		// iFrame.setAttribute('frameborder', '0');
		iFrame.setAttribute('scrolling', 'no');
		//iFrame.scrolling = 'no';
		//iFrame.frameBorder = 0;
				
		iFrame.style.maxHeight = 'none';
		iFrame.style.minHeight = '0px';
		
		iFrameArr.push(obj);
		
		//makes the activation message
		strActivationMessage = "ActivateEurolandToolAutoSizeObject-" + obj.index;
		if(isHeightToParent) {
			strActivationMessage += '-1';
		}
		
		//sends the activation message to the tool
		iFrame.contentWindow.postMessage(strActivationMessage, '*');
		
		//just to be safe sends the activation message to the Tool again onload
		iFrame.onload = function() {
			iFrame.contentWindow.postMessage(strActivationMessage, '*');
		}
	}
	
	this.set = function(iFrameID, reziseCallback, isHeightToParent) {
	/*
		Sets a tool to run in a spesific container
		iFrameID - String/HTML DOM Object, aider the ID of the iframe in question or the iframe itself as HTML DOM Object
		
		reziseCallback - [Optional] Function, the callback that will be called with the iframe's offset passed to it
		isHeightToParent - [Optional] Boolean, if set to TRUE the AutoHeight will ask the height to be sent to the parent and not into the top window
	*/
		var iFrame;
		
		if(!window.postMessage || IE_Version && IE_Version < 8) {
			return;
		}
		
		if(typeof reziseCallback != 'function') {
			reziseCallback = dummyCallback;
		}
		if(typeof isHeightToParent != 'boolean') {
			isHeightToParent = false;
		}
		
		switch(typeof iFrameID) {
			case 'string':
				try {
					iFrame = document.getElementById(iFrameID);
				} catch(e) {
					return false;
				}
				break;
			case 'object': 
				if(iFrameID == null)
					return false;
				iFrame = iFrameID;
				break;
			default:
				return false;
		}
		
		if(typeof iFrame != 'object' || iFrame == null || !iFrame.nodeName || iFrame.nodeName.toLowerCase() != 'iframe')
			return;		
		
		if(!hasListiners) {
			hasListiners = true;
			if(window.addEventListener) {
				window.addEventListener('message', messageCall);
			} else {
				window.attachEvent('onmessage', messageCall);
			}
		}		
		
		setIFrame(iFrame, reziseCallback, isHeightToParent);
	};
})();

//Adds in JSON support if missing
var JSON;if(!JSON){JSON={};}(function(){'use strict';function f(n){return n<10?'0'+n:n;}if(typeof Date.prototype.toJSON!=='function'){Date.prototype.toJSON=function(key){return isFinite(this.valueOf())?this.getUTCFullYear()+'-'+f(this.getUTCMonth()+1)+'-'+f(this.getUTCDate())+'T'+f(this.getUTCHours())+':'+f(this.getUTCMinutes())+':'+f(this.getUTCSeconds())+'Z':null;};String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(key){return this.valueOf();};}var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={'\b':'\\b','\t':'\\t','\n':'\\n','\f':'\\f','\r':'\\r','"':'\\"','\\':'\\\\'},rep;function quote(string){escapable.lastIndex=0;return escapable.test(string)?'"'+string.replace(escapable,function(a){var c=meta[a];return typeof c==='string'?c:'\\u'+('0000'+a.charCodeAt(0).toString(16)).slice(-4);})+'"':'"'+string+'"';}function str(key,holder){var i,k,v,length,mind=gap,partial,value=holder[key];if(value&&typeof value==='object'&&typeof value.toJSON==='function'){value=value.toJSON(key);}if(typeof rep==='function'){value=rep.call(holder,key,value);}switch(typeof value){case'string':return quote(value);case'number':return isFinite(value)?String(value):'null';case'boolean':case'null':return String(value);case'object':if(!value){return'null';}gap+=indent;partial=[];if(Object.prototype.toString.apply(value)==='[object Array]'){length=value.length;for(i=0;i<length;i+=1){partial[i]=str(i,value)||'null';}v=partial.length===0?'[]':gap?'[\n'+gap+partial.join(',\n'+gap)+'\n'+mind+']':'['+partial.join(',')+']';gap=mind;return v;}if(rep&&typeof rep==='object'){length=rep.length;for(i=0;i<length;i+=1){if(typeof rep[i]==='string'){k=rep[i];v=str(k,value);if(v){partial.push(quote(k)+(gap?': ':':')+v);}}}}else{for(k in value){if(Object.prototype.hasOwnProperty.call(value,k)){v=str(k,value);if(v){partial.push(quote(k)+(gap?': ':':')+v);}}}}v=partial.length===0?'{}':gap?'{\n'+gap+partial.join(',\n'+gap)+'\n'+mind+'}':'{'+partial.join(',')+'}';gap=mind;return v;}}if(typeof JSON.stringify!=='function'){JSON.stringify=function(value,replacer,space){var i;gap='';indent='';if(typeof space==='number'){for(i=0;i<space;i+=1){indent+=' ';}}else if(typeof space==='string'){indent=space;}rep=replacer;if(replacer&&typeof replacer!=='function'&&(typeof replacer!=='object'||typeof replacer.length!=='number')){throw new Error('JSON.stringify');}return str('',{'':value});};}if(typeof JSON.parse!=='function'){JSON.parse=function(text,reviver){var j;function walk(holder,key){var k,v,value=holder[key];if(value&&typeof value==='object'){for(k in value){if(Object.prototype.hasOwnProperty.call(value,k)){v=walk(value,k);if(v!==undefined){value[k]=v;}else{delete value[k];}}}}return reviver.call(holder,key,value);}text=String(text);cx.lastIndex=0;if(cx.test(text)){text=text.replace(cx,function(a){return'\\u'+('0000'+a.charCodeAt(0).toString(16)).slice(-4);});}if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,'@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,']').replace(/(?:^|:|,)(?:\s*\[)+/g,''))){j=eval('('+text+')');return typeof reviver==='function'?walk({'':j},''):j;}throw new SyntaxError('JSON.parse');};}}());

//Adds in a jQuery plugin
if (typeof jQuery == 'function') {
	(function ($) {
		/*
			Creates the [EurolandCommoditiesPeersIndices] Object
		*/
			
		// $.fn.EurolandIFrameAutoHeight = function() {
			
			// for(var i = 0; i < this.length; i++) {
				// EurolandToolIntegrationObject.set(this[i]);
			// }
			// return this;
		// };
		
		$.fn.extend({
			EurolandIFrameAutoHeight : function(resizeCallback) {
				
				if(typeof resizeCallback != 'function') {
					resizeCallback = null;
				}
				
				for(var i = 0; i < this.length; i++) {
					EurolandToolIntegrationObject.set(this[i], resizeCallback);
				}
				return this;
			}
		})

	}(jQuery));
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
    /* Fetch hash from URL and scroll to target while collapsing it */
	$(window).on('load', function(e){
		if(!$('.faq-module').length) return;
		if(window.location.hash) {
			var $target = $(window.location.hash);
			$($target.parent().data('target')).collapse('show');
		}
	});
	/* On click fetch href, scroll to said href and change hash in URL to target href */
    $('.faq-module').on('click', '[data-target]', function() {
        var $target = $($(this).attr('href'));
        var scrollTarget = $target.offset().top - $(this).height(); // -30 to compensate for div height.
        var $collapsible = $target.closest('.faq-module').find('.collapse.show');
        // Check if an accordion is collapsed.
        if($collapsible.length > 0) {
            // If its collapsed, check if its height is bigger than the targets height.
            if($(this).offset().top > $collapsible.offset().top) {
                scrollTarget = $target.offset().top - $target.closest('.faq-module').find('.collapse.show').height() - $(this).height();
            }
        }
        $('html, body').animate({
            scrollTop: scrollTarget
        }, 500);
        window.location.hash = $(this).attr('href');
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function() {
    $('.toggle-filters').on('click', function () {
        $('.toggle-filters-elements').toggle();
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function() {
    $('.video-thumbnail').on('click', function () {
        playEmbededVideos(this);
    });
    replaceVideoWithThumbnail();
});

function replaceVideoWithThumbnail(){
    $('.video').each(function(){
        var $rawVideo = $(this).find('.video-embeded');
        var $thumbNail = $(this).find('.video-thumbnail');
        if($thumbNail.length > 0){
            $rawVideo.hide();
        }
    });
}

function playEmbededVideos(videoThumbnail) {
    var videoEmbeded = $(videoThumbnail).parent().find(".video-embeded");
    var iframe = videoEmbeded.find("iframe");
    var videoURL = iframe.prop('src');

    iframe.prop('src',videoURL += "?rel=0&autoplay=1");

    setTimeout(function(){
        $(videoThumbnail).hide();
        videoEmbeded.show();
    }, 200);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(function() {
    var $el = $('.heroslider-zoom-animation');
    $(window).on('scroll', function () {
        var scroll = $(document).scrollTop();

        $el.css({
            'background-size': (scroll > 0 ? 100 + ((scroll / 9.99) / 2) : '100') + '%'
        });
	    
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
	$('.eurotools-auto-iframe').EurolandIFrameAutoHeight();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {function ImageSlider(element) {
  this.element = element
  this.inner = this.element.find('.ImageSlider__inner')
  this.slides = this.element.find('.ImageSlider__slide')
  this.indicators = this.element.find('.ImageSlider__indicators')
  this.buttons = this.element.find('.ImageSlider__buttons')
  this.index = 0

  this.indicators.on('click', 'li', this.handleIndicatorClick.bind(this))
  this.buttons.on('click', 'a', this.handleButtonClick.bind(this))

  var count = this.slides.length
  var slideWidth
  if(window.innerWidth <= 992) {
      slideWidth = count * 600 + 1200
      if(window.innerWidth <= 768) {
          slideWidth = count * 400 + 800
      }
  } else {
      slideWidth = count * 760 + 1520
  }
  this.inner.css({
      'min-width': slideWidth + 'px',
  });

  if (this.slides.length > 1) {
    this.slides.last().clone().prependTo(this.inner)
    this.slides.first().clone().appendTo(this.inner)
  } 

  this.move()
}

ImageSlider.prototype.handleIndicatorClick = function(event) {
  this.index = parseInt($(event.target).attr('data-target'))
  this.move()
}

ImageSlider.prototype.handleButtonClick = function(event) {
  event.preventDefault()

  const slide = $(event.target).attr('data-slide')

  if (slide === 'next') {
    this.index = (this.index + 1)
  } else {
    this.index = (this.index - 1)
  }

  this.move()
}

ImageSlider.prototype.move = function() {
  var count = this.slides.length

  this.index = ((this.index % count) + count) % count

  var change = 0
  var slideWidth

  if(window.screen.width < 992) {
    slideWidth = count * 400 + 800
  }

  if (count > 1) {
    change = -1 * ((100 / (count + 2)) * ((this.index + 1) % (count + 2)))
  }

  this.inner.css({
    '-webkit-transform': 'translateX('+ change +'%)',
    '-moz-transform' : 'translateX('+ change +'%)',
    '-ms-transform': 'translateX('+ change +'%)',
    '-o-transform': 'translateX('+ change +'%)',
    'transform': 'translateX('+ change +'%)',
    'min-width': slideWidth + 'px',
  })

  this.updateActive()
}

ImageSlider.prototype.updateActive = function() {
  const indicators = this.indicators.find('li')
  indicators.removeClass('active')
  $('.ImageSlider__slide--active').removeClass('ImageSlider__slide--active')

  $(this.slides[this.index]).delay(600).addClass('ImageSlider__slide--active')
  $(indicators[this.index]).addClass('active')
}

$(document).ready(function() {
  $('.ImageSlider').each(function() {
    new ImageSlider($(this))
  })

  $('.brand-presentation.d-none .carousel-item').each(function() {
    var that = $(this)
    var next = that.next()
    var prev = that.prev()

    if (!next.length) {
      next = that.siblings(':first');
    }

    if (!prev.length) {
      prev = that.siblings(':last')
    }

    // find the original node
    next.children('[class="row"]')
        .clone()
        .addClass('carousel-item--preview carousel-item--preview--right')
        .appendTo(that)

    // find the original node
    prev.children('[class="row"]')
        .clone()
        .addClass('carousel-item--preview carousel-item--preview--left')
        .prependTo(that)
  })
})
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function(){
    $('.search-icon').on('click', function() {
        if($('.navbar-collapse').hasClass('show')) {
            $('#main-menu-toggler').click();
        }
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
    $('.tabs-module .tabs-module-link').on('click', function(e) {
        e.preventDefault();
        $('.tabs-module .tabs-module-link').removeClass('tabs-active');
        $(this).addClass('tabs-active');
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
	$(document).on('show.bs.modal', '#videoModal', function (event) {
		var videoUrl = $(event.relatedTarget).data('videourl');
		/* Replace the question mark with a parameter which allows auto pause on close window */
		var newUrl = videoUrl.replace(/[?]/, '?enablejsapi=1&');
		$(this).find('.modal-content').html(newUrl);
	});
	$(document).on('hide.bs.modal', '#videoModal', function () {
		$(this).find('iframe')[0].contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*'
		);
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
	var ids = ["#fornavn", 
			"#etternavn", 
			"#epost", 
			"#adresse", 
			"#by", 
			"#land", 
			"#rolle", 
			"#orklaAnnualReport", 
			"#generalFormCollectionDocuments",
			"#selskap",
			"#postnummer"
		];
	ids.forEach(function(inputValue) {
		$(inputValue).keyup(function() {
			var value = $(this).val();
			$(inputValue+"Value").text(value);
		});
	});
	$('.validateButton').on('click', function(e) {
		if($('#annual-report-form')[0].checkValidity()) {
			$($(this).data('target')).addClass('active')
				.siblings().removeClass('active');
			if($('#bestillerSom1').prop("checked")) {
				$('#bestillerSomValue').text("Privatperson");
			} else {
				$('#bestillerSomValue').text("Selskap");
			}
			$('#rolleValue').text("" + $('#rolle option:selected').text());
		} else {
			const tmpSubmit = document.createElement('button');
			tmpSubmit.className = "d-none";
		    $('#annual-report-form').append(tmpSubmit);
		    tmpSubmit.click();
		    $('#annual-report-form').remove(tmpSubmit);
		}
	});
	$('.page-toggler').on('click', function(e) {
		e.preventDefault();
		$($(this).data('target')).addClass('active')
			.siblings().removeClass('active');
	});
	$('.btn-group-toggle .btn').on("click", function() {
		$(this).children('input').prop('checked', true);
	});
	$('.company-toggle').on('click', function(e) {
		$('.selskap-wrapper').show();
		$('#selskap').prop('required',true);
	});
	$('.person-toggle').on('click', function() {
		$('.selskap-wrapper').hide();
		$('#selskap').prop('required',false);
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
	var sort = __webpack_require__(142);
	var items = document.querySelectorAll(".item");
	$(".id-label").clickToggle(function() {
		sort(items, {data:'id',order:'asc'});
	}, function() {
		sort(items, {data:'id',order:'desc'});
	});
	$(".desc-label").clickToggle(function() {   
		sort(items, {data:'desc',order:'asc'});
	}, function() {
		sort(items, {data:'desc',order:'desc'});
	});
});
jQuery.fn.clickToggle = function(a,b) {
	var ab = [b,a];
	return this.on("click", function(e){
		e.preventDefault();
		ab[this._tog^=1].call(this);
	});
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function(){
	// Check if element has hidden content
	$(".brands-detail").each(function() {
		var $el = $(this)
		var $body = $el.find(".content-body");
		var overflowed = $body[0].scrollHeight > $body[0].clientHeight;

		if(!overflowed) {
			$(".brands-detail-body-text").addClass("mb-40");
			$(".showLessButton").addClass('hide');
			$(".showMoreButton").addClass('hide');
			$(".showLess").addClass('hide');
		} else {
			$(".showMoreButton").on("click", function() {
				$(".showLess").toggleClass("hide");
				$(".showMoreButton").toggleClass("hide");
				$(".showLessButton").toggleClass("hide");
				$(".content-body").toggleClass("expanded");
			});
			$(".showLessButton").on("click", function() {
				$(".showLess").toggleClass("hide");
				$(".showMoreButton").toggleClass("hide");
				$(".showLessButton").toggleClass("hide");
				$(".content-body").toggleClass("expanded");
			});
		}
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$('.toggler-downloadcenter').on('click', function() {
    $(this).find('.toggler-icon-downloadcenter').toggleClass('active');
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function(){
    $(".accordion-toggle").on("click", function() {
        $(this).find(".collapse-plus,collapse-minus").toggle();
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
	$('.vote-button').on('click', function () {
		$('.taste-vote').html($(this).data('taste')); //Data value
		$('.voted-image').attr('src', ($(this).data('image'))); //Pass image from front-page sillkampen
		$('.voted-container-second').css('background', $(this).data('background')); //Pass background color
		$('.percentage-container-second').html($(this).data('percentage'));
	
		$(this).parent().find('input[type=radio]').prop("checked", true);
	});

	$('.vote-type-button').on('click', function () {
		$(this).parent().find('input[type=radio]').prop("checked", true);
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, $) {jQuery(function($) {
    var index = 0;
    var correctAnswers = 0;
    var amountOfQuestions = $('.question-container').length;
    $('.answer-container').on('click', '.answers', function (e) {
        var $correctAnswerSelector = $(this).parent().find($('.correct-answer'));
        index++;
        questionToggle(index);
        // e.target.id is a string, data attribute is int.
        // Need to parseInt for strict type comparison.
        if(parseInt(e.target.id) === $correctAnswerSelector.data("answer")) {
            correctAnswers++;
        }
        if(index === amountOfQuestions) {
            if(correctAnswers === amountOfQuestions) {
                $('.completed-quiz-container').toggleClass('show');
            } else {
                $('.incomplete-quiz-container').toggleClass('show');
            }
        }
    });

    $('.restart-quiz').on('click', function(e) {
        location.reload();
    })
});

/**
 * Hide current question, show next.
 * @param {number} index - which has been incremented before every call to toggle correctly
 */
function questionToggle(index) {
    var currentQuestion = $('.single-quiz-container').find('.show');
    currentQuestion.toggleClass('show');
    $('#question-id-' + index).toggleClass('show');
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function($) {
	$('.recipe-servings-plus, .recipe-servings-minus').on('click', function(e) {
		$('.ingredient-quantity').each(function(i, ingredient) {
			servings = parseFloat($('.servings-amount').html());
			var amount = parseFloat($(ingredient).data('ingredient-quantity')) / servings;
			var ingredientAmount = "";
			if ($(e.target).hasClass('recipe-servings-plus')) {
				ingredientAmount = amount * (servings+1);
				setIngredientData(ingredient, ingredientAmount);
			} else if(servings > 1) {
				ingredientAmount = amount * (servings-1);
				setIngredientData(ingredient, ingredientAmount);
			}
		});
		if ($(e.target).hasClass('recipe-servings-plus')) {
			$('.servings-amount').html(servings + 1);
		} else if(servings > 1) {
			$('.servings-amount').html(servings - 1);
		}
	});
	function setIngredientData(ingredient, amount) {
		$(ingredient).html(round(amount));
		$(ingredient).data('ingredient-quantity', amount);
	}
	function round(num) {
	    return Math.round(num*4)/4;
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function() {
    $('.recipe-archive-time').on("change",function() {
        $(".recipe-archive-time").addClass("select-box-arrow");
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function () {
    if ($('.sticky-scroll-box').length) {
        var $window = $(window),
            $stickyEl = $('.sticky-scroll-box'),
            elTop = $stickyEl.offset().top;

        $window.scroll(function () {
            $stickyEl.toggleClass('fixed', $window.scrollTop() > elTop);
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_BwFrontendTheme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_scss__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main_scss__);
// Import main base js.






/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Ilmastojälki_taulukko-acba935d89d5b81aff25fcd175355bf1.jpeg";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "orkla-klimatskala-6ab66b9502f28b8d979e086455c0eb0c.png";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon-9f6c20b2f346733d27972285490e9579.ico";

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "file-8fb8ef664335ca092b8ef304cc920ddc.svg";

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ics-c7f6ee5eacc4402f61ff01728810167f.svg";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "link-d2a372bb0044de89e9db9f4b98c9c9da.svg";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mp3-7a4f3260721a327a31d8e23ff1b4652b.svg";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "other-8fb8ef664335ca092b8ef304cc920ddc.svg";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pdf-ffbc95ada40867d6da8a11ca5e50fa6e.svg";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "presentation-c37e8fbe23723d2cfb1534e450e0dd24.svg";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "webcast-14f96098d4ffc3efea7819d30929b620.svg";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "xlsx-00f1128bf702cff4154773ffb27d3181.svg";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow-down-white-91cb841fe5e72e802c9444383985ced3.svg";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow-down-479c6d3858b48803716c18765601729c.svg";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cross-white-6ab9fc1453f88d695840869dc4e63987.svg";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cross-b34958b9651a35b7f888a0c6f913c77a.svg";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "minus-icon-4a5f7aebe596fca2cd22cad73eb200f3.svg";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new-window-link-2153c64b002471d4a35db2fd36e443a3.svg";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "plus-icon-b520292b63691f44ae94626312181bd9.svg";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-black-3ecd2e0902e3f5d589cea489f2da6457.svg";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-denmark-footer-c47a7ea3d58461f39754de358cfbad96.svg";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-gray-9d09dc3e58bf54e7dfa7b254447d0108.svg";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-com-white-b7c03cae078a80f7a8d038c8c319af9b.svg";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-com-98680d1e1538648a6be55c64a97de1b5.svg";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-dk-white-1e8c1ad574f969c8864681e4e8429eb9.svg";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-dk-40323cb974fde20b63c2a406ac2756be.svg";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-es-1db4cc1147a2a5206bcb91330b94e525.svg";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-fi-white-8cbb43497c7058927935c78c90d23062.png";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-fi-white-5d6032913d36e1b26d8d855798d7ae22.svg";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-fi-bf573a645f6dcf54f9105cd87f399985.png";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-fi-828d98fcdd059e5df4088239159dc8f5.svg";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-no-white-569ee305732c6bb338e5162ae21959d6.svg";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-no-da8c3055c403c41423d0195f4a1ac2af.svg";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-se-white-ad6a3ce3cb45d4bac042c099e47ca067.svg";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-orkla-tagline-se-ea5d4819e77e843a0cfeb523c68aee2c.svg";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-without-payoff-1f37f053bdc3d024065873e1170f0e17.svg";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ASC_logo-a99b928762380a4c675c6531c96cd061.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "MSC_Swedish_Portrait_Blue_RGB-f470c83eb978faf7dfe57acd38140185.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "OFF_ClimateLabel_FI-03-78ea0f5cbd62ab1f208d04f180bb9f62.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Rainforest-kakao-fb9be5ed5c2536ecb734e5ee1ae47128.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Utz_certified_logo.svg-6ced8f798e5fdf987ed375133122ba92.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "allergiatunnus_fi_4vari-e18ad66012e873a17c1ef91dd6d11820.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eu_organic_logo-ff249db90687a4f3848459242f2cbe6e.png";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-battre-val-1e81b6b93915f59f30f098eb8a77fa28.png";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-blue-flag-8f898be1d07363e582f182d99c17b53a.png";

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-blue-swan-352786fe13958ca81e5183aab060318f.png";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-eu-leaf-998bcf6a7567da096cc612b93adea60c.png";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-msc-021f087a6d2716dacbf521cd533171cf.png";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-rainforest-alliance-cocoa-hazelnut-59d077f460e779efb6505769d67e6956.png";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-rainforest-alliance-cocoa-d7529819b90c6b4dcdf7ce7dc5a720ae.png";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi-utz-cocoa-2eaf8b1fdd2857cc7ce65b0bd146e07e.png";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "från_sverige-793e84fbf3665eb699388391f7ac00e2.png";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "krav_marke_farg-65c4c73962a432f063e0f37d6a53f288.png";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nyckelhal_farg-030b4c7119ea17a3394bf2075d75f51e.png";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "facebook-icon-small-8b626bab65780c1f646034c8838d0542.svg";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "instagram-icon-small-d8a251a90c9bc367ff3065c2005bff87.svg";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "linked-in-icon-small-cbe7bbf42c824ebdd8699afc8a649b20.svg";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mail-icon-small-9d4fd2050159f395ff7b32b65a1325c8.svg";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pinterest-icon-small-3562bf24ce15d6bbf017c80f7d677550.svg";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "print-4811f6f1b2da6b1618e1c831c3110472.svg";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "twitter-icon-small-6159d5f0c669daf994beb0301edc49c3.svg";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "youtube-icon-small-21b737fa67f252f93bed75904c5411f2.svg";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1-filled-8cd08c0d93c00d720d348b964ab713f1.svg";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "10-filled-92a642bbe65b1d579341273d9e78a6a3.svg";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11-filled-6f1f368f14da465e2fdb2d4242670794.svg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "12-filled-a263f0731c750ddc03c5ff65b37391d3.svg";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "13-filled-f33784fd7cd8ffa957fc092d99fb8551.svg";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14-filled-ca5b2bfde9ff46b2e24addaf71269079.svg";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "15-filled-e414029950813b14ea2843adb7cddb61.svg";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "16-filled-0d2d583c87e9bbfba1d741902af8e6f8.svg";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "17-filled-2d32853b81e384b4219e2de5282eb595.svg";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18-filled-6737e11baef34bb5ebaf2ceb3f28ef16.svg";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19-filled-d7eb3ec7bd729f4ea1763f0c5a3cedf6.svg";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2-filled-21ac79075f396344de366ae5a2d72803.svg";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20-filled-97754638de238138977d18f7146abd1f.svg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3-filled-3fab0095ca84c6fa2f0daf8ee46f1d1a.svg";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4-filled-e24f74d31242b04eda4c6e9fdefc514c.svg";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5-filled-77d6c3688f40dc6ed66a377986d4f7ca.svg";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6-filled-fa0530b94da1bc51e0e9d4ef7fdeeb89.svg";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7-filled-8cfca1ce8fc8a50a9c6d8e690b5bd727.svg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8-filled-e0a552a0d8957dace64c2a97d9c394d9.svg";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9-filled-915b4ad86525ed43fe20d9fb4c49d7b9.svg";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1-lined-c78757a377144704cb933c2833ee7a51.svg";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "10-lined-a3cc21554a8218424ca7099fdc6c0112.svg";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11-lined-8d33438f6abee0680f307b1f6efc4bb1.svg";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "12-lined-96c03ea587aeaba2c2ca63b6094fd79b.svg";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "13-lined-fa098edf30266f5e7e2d40302cfaa046.svg";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14-lined-b42fd3946bbb3516323dd2aa3fda1154.svg";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "15-lined-b4735c8e7078ecd8e6d251d4ab003ae3.svg";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "16-lined-cfc14511ab86bc446877cc47b340d375.svg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "17-lined-4906aa8389eb3588a4e5d1145ef35a91.svg";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18-lined-c4edcaa6e709e7b103ec36e1648c02eb.svg";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19-lined-68e67b6cb653dcb9547bb58bab688937.svg";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2-lined-87d3ed2b63e121b4101468c81240c0a9.svg";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20-lined-443da75bb86bd334e05e4c8b954546de.svg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3-lined-d981109e03126b56df3bdb84ff51a4c5.svg";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4-lined-c6996e9faa3e5b4a6ba158130ca5056a.svg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5-lined-5562adb34b7ebc67fae1e1e1522a0bd7.svg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6-lined-666e03b5716470eee6a11ad812184624.svg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7-lined-3890eb5be5bc3ffbae3e1578e4b9e4fb.svg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8-lined-360d83b0b1e716ac2d8c7c6208a1e941.svg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9-lined-ff4f11c55908f74645587b379014b72e.svg";

/***/ })
],[36]);


// WEBPACK FOOTER //
// main-eb869d63b1781cdc3460.js